import Konva from 'konva';
import ConfiguratorSofa from './ConfiguratorSofa';
import ConfiguratorPerson from './ConfiguratorPerson';
import Popup from "./partials/Popup";
import Pillows from "./partials/Pillows";
import MaterialAlert from "./partials/MaterialAlert";
import Events from "../Events";
import NoModuleSofa from "./NoModuleSofa";
import scrollbar from "../../scrollbar";
// import ModulePosition from "./ModulePosition";
import PreOrderPopup from "./partials/PreOrderPopup";

let object = null;

class ConfiguratorCanvas {

    constructor() {
        if (!object) {
            object = this;
        }

        Konva.showWarnings = false;

        /*Лоадер*/
        this.$loader = $('.configurator__canvas-wrap');

        /*Лоадер для опций*/
        this.$loaderOptions = $('.options-section--model-choose .js-ajax-loader');

        /*Общий контейнер*/
        this.$container = $('#configurator-canvas');

        this.containerWidth = this.$container.width(); /*ширина контейнера*/
        this.containerHeight = this.$container.height(); /*высота контейнера*/

        /*Общий стейдж (контейнер Konva)*/
        this.stage = new Konva.Stage({
            container: 'configurator-canvas',
            width: this.containerWidth,
            height: this.containerHeight
        });

        this.sofa = new ConfiguratorSofa(this); /*Экземпляр конфигуратора*/
        this.person = new ConfiguratorPerson(this); /*Экземпляр человека для масштаба*/
        this.events = new Events; /*Экземпляр класса для обработки событий*/
        this.preOrderPopup = new PreOrderPopup(this); /*Экземпляр класса для показа попапа перед заказом*/
        this.configData = this.sofa.configData; /*Общее хранилище данных*/
        this.roomInited = false; /*Отрендерена ли комната*/
        this.materialAvailable = true; /*Доступны ли рендеры для текущего материала*/
        this.deviceOrientation = this.sofa.helpers.checkDeviceOrientation(); /*Проверить ориентацию устройства, может быть landscape или portrait*/

        /*Объект для немодульного дивана*/
        this.noModuleSofa = new NoModuleSofa({
            sofa: this.sofa,
            configurator: this,
        })

        this.targetItems = false;/*Элементы для отслеживания области построения модулей*/
        this.blockTargetItems = false;/*Заблокировать элементы для отслеживания области построения модулей*/

        this.fullScale = 1;/*Общий масштаб, изменяется в зависимости от размера экрана*/

        this.layer = new Konva.Layer();/*Слой Konva (общий для всего)*/

        /*Масштабирование в зависимости от размера экрана*/
        if(window.innerWidth >= 1025) {
            this.layer.scaleX(1);
            this.layer.scaleY(1)
        }
        else if(window.innerWidth >= 850 && window.innerWidth <= 1024) {
            this.fullScale = 0.6;
            this.layer.scaleX(0.6);
            this.layer.scaleY(0.6);
        }
        else if(window.innerWidth >= 768 && window.innerWidth < 850 && this.deviceOrientation === 'landscape') {
            this.fullScale = 0.55;
            this.layer.scaleX(0.55);
            this.layer.scaleY(0.55)
        }
        else if(window.innerWidth >= 576 && window.innerWidth < 768 && this.deviceOrientation === 'landscape') {
            this.fullScale = 0.45;
            this.layer.scaleX(0.45);
            this.layer.scaleY(0.45)
        }
        else if(window.innerWidth >= 576 && window.innerWidth < 768 && this.deviceOrientation === 'portrait') {
            this.fullScale = 0.5;
            this.layer.scaleX(0.5);
            this.layer.scaleY(0.5)
        }
        else if(window.innerWidth >= 375 && window.innerWidth < 576) {
            this.fullScale = 0.35;
            this.layer.scaleX(0.35);
            this.layer.scaleY(0.35)
        }
        else {
            this.fullScale = 0.31;
            this.layer.scaleX(0.31);
            this.layer.scaleY(0.35)
        }

        if(window.innerWidth < 768 && this.deviceOrientation === 'landscape') {
            scrollbar('.js-scroll-options', '.js-scroll-options-scrollbar')
        }

        /*Радиус добавления модуля (центр первого/последнего модуля + значение)*/
        this.addModuleRadius = 100 * this.fullScale;

        this.stage.add(this.layer);

        this.init();

        return object;
    }

    init() {
        let object = this;

        /*Инициализируем данные*/
        object.initData(function () {

            object.sofa.sections = object.configData.sections[0]; /*объект с секциями*/
            object.sofa.startConfig = object.configData.startConfig[0]; /*стартовая конфигурация*/
            object.sofa.sofaName = object.configData.sofaName; /*название дивана*/
            object.interiorsCount = Object.keys(object.configData.interiors).length; /*кол-во интерьеров*/
            object.currentInterior = 1; /*текущий интерьер*/
            object.popup = new Popup(object); /*Объект для попапа*/
            object.pillows = new Pillows(object); /*Объект для подушек*/

            /*если немодульный диван, то увеличиваем масштаб картинок*/
            if(object.configData.noModuleSofa) {
                object.noModuleSofa.correctScale()
            }

            object.sofa.group.on('mouseenter', function() {
                object.stage.container().style.cursor = 'pointer';
            });

            object.sofa.group.on('mouseleave', function() {
                object.stage.container().style.cursor = 'default';
            });

            /*Загружаем картинки. Как только загружены - строим комнату*/
            object.loadImages(object.sofa.sections, object.buildStage);

            object.initEvents(); /*Инициализируем события для обычного DOM*/

            object.initCanvasEvents(); /*Инициализируем события для канваса*/

            object.initSections(); /*Инициализируем драг-н-дроп*/

            /*Делаем нужный цвет активным. Цвет либо Fancy-06 либо выставлен в админке*/
            object.initFirstCustomMaterial()
        });
    }

    /*Ajax для того чтоб получить данные из админки*/
    initData(callback) {

        let object = this;

        $.ajax({
            url: ajaxurl,
            type: 'post',
            dataType: 'json',
            data: {
                'postId' : object.sofa.currentSofa,
                'action' : 'get_sofas_data',
            },
            beforeSend: () => {
                console.log('Data initializing');
            },
            success: (response) => {

                /*заносим модули в хранилище*/
                object.configData.sofaName = response.sofaName;

                /*заносим модули в хранилище*/
                object.configData.sections = response.modules;

                console.log(object.configData.sections);
                console.debug(response);

                /*заносим стартовую конфигурацию в хранилище*/
                object.configData.startConfig = response.startConfig;

                /*Модульный или немоудльный диван?*/
                object.configData.noModuleSofa = response.noModuleSofa;

                /*Стартовый материал*/
                object.configData.customStartMaterial = response.customStartMaterial;

                /*Получить перевод некоторых фраз из админки*/
                object.sofa.helpers.getTranslatedPhrases(['см', 'грн'], object);
            },
            error : function (jqXHR, exception) {
                object.sofa.helpers.jqXHRMessage(jqXHR, exception)
            },
            complete: function () {
                callback();
                console.log('Data initializing finished');
            }
        });
    }

    /*Выставление изначального материала*/
    initFirstCustomMaterial() {
        let object = this
        let startCategory = object.configData.customStartMaterial.category
        let startNumber = object.configData.customStartMaterial.number
        let startMaterialItem = $('[data-material-true-name="' + startCategory + '"][data-material-color="' + startNumber + '"]')
        startMaterialItem.parents('.js-material-cat-item').find('img').removeClass('lazyload lazyloading')
        startMaterialItem.parents('.js-material-cat-item').find('.js-material-cat-name').eq(0).click()
        startMaterialItem.eq(0).click()
    }

    /*Инициализируем события для обычного DOM*/
    initEvents() {
        let object = this;
        let person = $('.js-configurator-person');

        $('.js-clear').on('click', function () {
            object.sofaGroupPosition = [0,0];

            //object.sofa.group.removeChildren();

            // console.log('remove');

            object.sofa.state = [];

            object.sofa.rebuild();

            object.layer.draw();
        });

        $('.js-configurator-linear').on('click', function() {
            let ths = $(this);
            ths.toggleClass('active');

            if(ths.hasClass('active')) {
                person.click();
                object.layer.add(object.sofa.linearGroup);
                object.layer.draw();
                person.click();
            }
            else {
                object.sofa.linearGroup.remove();
                object.layer.draw();
            }
        });

        person.on('click', function () {
            let ths = $(this);
            ths.toggleClass('active');

            let personItem = object.sofa.helpers.getPersonPositionBySofas(object.person, object.sofa);

            if (ths.hasClass('active')) {
                /*if (!object.person.isDrew && personItem) {
                    object.person.drawPerson(personItem);
                }*/
                object.person.drawPerson(personItem);

                object.layer.add(object.person.group);
                object.layer.draw();
            }
            else {
                object.person.group.remove();
                object.person.group.removeChildren();
                object.person.isDrew = false;
                object.sofa.rebuild();
                object.layer.draw();
            }
        });

        $('.js-configurator-pdf').on('click', function () {
            object.events.generatePdf(object);
        });

        $('.js-constructor-pre-order').on('click', function () {
            object.events.sendEmail(object);
        });

        $('.js-configurator-call-pre-order-table').on('click', function () {
            object.preOrderPopup.build()
        });

        $('.js-material-item').on('click', function () {
            object.events.checkMaterial($(this),object);
        });

        $('.no-image-alert--canvas .close').on('click', function () {
             $(this).parent().css('display', 'none');
        });

        let confShare = $('.js-configurator-share');
        confShare.on('click', function () {
            let ths = $(this);
            let share = ths.find('.addtoany_shortcode');

            share.toggleClass('active');
            ths.toggleClass('active');
        });

        object.sofa.helpers.clickOutOfElement(confShare);

        $('.js-configurator-change-interior').on('click', function() {
            object.currentInterior = object.currentInterior >= object.interiorsCount ? 1 : object.currentInterior + 1;

            if(object.configData.interiors[object.currentInterior]['type'] === 'image') {
                let interiorSrc = object.configData.interiors[object.currentInterior]['img'].src;

                object.sofa.helpers.executeIfFileExist(interiorSrc, function () {
                    object.layer.find('.roomBg').image(object.configData.interiors[object.currentInterior]['img']);
                    object.layer.draw();
                });
            }
            else {
                object.layer.find('.roomBg').image(null);
                object.layer.draw();
            }

        });

        $(document).on('click', '.js-pillows-toggle', () => {

            let $item = $('.js-material-pillows .is-current')
            if(this.pillows.isDrawn) {
                this.pillows.destroyPillows()
            }
            else {
                this.pillows.showPillows($item)
            }
        })

        $(document).on('click', '.js-material-pillow-item', function (el) {
            let $item = $(this);
            object.pillows.destroyPillows()
            object.pillows.showPillows($item)
        })

        $('.js-synchronize-canvas-translations').on('click', function () {
            object.sofa.helpers.synchronizeCanvasTranslations(object.sofa.sofaId, object)
        })
    }

    /*Инициализируем события для канваса*/
    initCanvasEvents() {

        console.log('Turn on canvas events');

        let object = this;

        object.stage.on('click touchstart', function (e) {

            object.popup.destroy();
            let shapes = object.sofa.group.find('.strokeShape');

            // Remove all opened popups
            for(let i = 0; i < shapes.length; i++) {
                let item = shapes[i];

                item.strokeWidth(0);
            }

            // IF - Click outside sofa
            if((e.target instanceof Konva.Shape && e.target instanceof Konva.Line) || !(e.target instanceof Konva.Shape)) {
                object.sofa.rebuild();
                object.layer.draw();
            }
            // ELSE - Click on sofa
            else {
                let shape = e.target;

                for(let n = 0; n < object.sofa.state.length; n++) {
                    let item = object.sofa.state[n];

                    if(item.index === shape.stateId) {

                        let position = Object.assign({}, object.sofa.helpers.minFromCoordinates(shape.coordinates));
                        position.x = shape.x() + (position.x * object.sofa.scale);
                        position.y = shape.y() + (position.y * object.sofa.scale);

                        /*если нажали на кресло*/
                        if(item.isChair) {
                            object.popup.buildPopup(position, item.id, n, n);

                            // console.log('клик по креслу');
                        }
                        /*если кресло есть, но нажали на другой модуль*/
                        else if(object.sofa.chair.exists && !item.isChair) {

                            // console.log('клик не по креслу но кресло есть');
                            // console.log('n', n)
                            // console.log('object.sofa.edgeModules.first.index', object.sofa.edgeModules.first.index)

                            if(n === object.sofa.edgeModules.last.index || n === object.sofa.edgeModules.first.index) {
                                // console.log("выделяем модуль который после кресла");
                                object.popup.buildPopup(position, item.id, n, n)
                            }
                            else {
                                object.popup.buildPopup(position, item.id, n)
                            }
                        }
                        else {
                            if(n === 0 || n === object.sofa.state.length - 1) {
                                object.popup.buildPopup(position, item.id, n, n)
                            }
                            else {
                                object.popup.buildPopup(position, item.id, n)
                            }
                        }
                    }
                }

                shape.strokeWidth(4);
                object.layer.draw();
            }
        });

        $('.js-check-all-canvas-materials').click(function () {
            object.events.checkAllMaterials(object);
        })
    }

    // Добавить секции в будущий диван
    buildStage(object) {
        // console.log('images loaded');
        object.addRoom();
        object.materialAlert = new MaterialAlert(object);

        object.sofa.state = []; //удалить текущий диван для смены цвета

        if(typeof sessionStorage.canvasState === "undefined" || !object.sofa.debug) {
            let currentPosition = 0; //в какую сторону повернут диван
            let positions = ['frontLeft', 'front', 'frontRight', 'back'];

            let sections = object.sofa.startConfig; //теперь выставляется в админке для каждого дивана
            console.log('sections on buildStage', sections)

            // if(typeof object.sofa.sofaName !== "undefined") {
            //     console.log('object.sofa.sofaName', object.sofa.sofaName)
            //     if(object.sofa.sofaName === 'Tutto') {
            //         sections = [0,1,0]
            //     }
            //
            //     if(object.sofa.sofaName === 'Ermes') {
            //         sections = [0,1]
            //     }
            // }

            sections.forEach((item, index) => {
                if(object.sofa.sections[item]['isAngle']) {
                    currentPosition ++;
                    if (currentPosition === 4) currentPosition = 0;
                }

                object.sofa.addSection({
                    _id: index,
                    position: positions[currentPosition],
                    id: item,
                    highlight: 0,
                    connectedModule: object.sofa.sections[item]['connected_module'],
                    prepends: positions[currentPosition] === 'frontLeft',
                    isAngle: object.sofa.sections[item]['isAngle'],
                    configurationWithAngle: object.sofa.sections[item]['configurationWithAngle'],
                    isArmrest: object.sofa.sections[item]['isArmrest'],
                    isChair: object.sofa.sections[item]['isChair'],
                    sizes: object.sofa.sections[item]['sizes'],
                    from: 'from initial'
                });
            });
        }
        else {
            object.sofa.state = JSON.parse(sessionStorage.canvasState);
        }

        object.sofa.rebuild();

        object.callSofaMethods();

        object.layer.add(object.sofa.group);

        object.layer.draw();
    
        /*Если немодульный диван, то вызываем метод для обработки первого модуля*/
        if(object.sofa.configData.noModuleSofa) {
            object.noModuleSofa.makeFirstModuleAsAngle();
        }
        else {
            object.$loader.removeClass('is-loading');
        }
/*
        $('.js-configurator-linear')[0].click();
        $('.js-configurator-change-interior')[0].click()*/
    }

    /*Загружаем картинки. Как только загружены - строим комнату*/
    loadImages(sections, callback) {
        console.log('Loading images');
        let object = this;
        let images = [];

            console.log(object.sofa.sections);
        Object.keys(sections).forEach(function (section) {

            let sectionObject = object.sofa.sections[section];

            console.debug(sectionObject);

            if(sectionObject['image']['front']['src'] !== '') {
                sectionObject['image']['front']['img'] = new Image();
                sectionObject['image']['front']['img'].src = sectionObject['image']['front']['src'];
                images.push(sectionObject['image']['front']['img']);
            }
            else {
                console.log('%cИзображение не существует! Разворот: front. Модуль: ' + sectionObject.name, 'background: #ffb9b9; color: #171414')
            }

            if(sectionObject['image']['back']['src'] !== '') {
                sectionObject['image']['back']['img'] = new Image();
                sectionObject['image']['back']['img'].src = sectionObject['image']['back']['src'];
                images.push(sectionObject['image']['back']['img']);
            }
            else {
                console.log('%cИзображение не существует! Разворот: back. Модуль: ' + sectionObject.name, 'background: #ffb9b9; color: #171414')
            }

            if(sectionObject['image']['frontLeft']['src'] !== '') {
                sectionObject['image']['frontLeft']['img'] = new Image();
                sectionObject['image']['frontLeft']['img'].src = sectionObject['image']['frontLeft']['src'];
                images.push(sectionObject['image']['frontLeft']['img']);
            }
            else {
                console.log('%cИзображение не существует! Разворот: frontLeft. Модуль: ' + sectionObject.name, 'background: #ffb9b9; color: #171414')
            }

            if(sectionObject['image']['frontRight']['src'] !== '') {
                sectionObject['image']['frontRight']['img'] = new Image();
                sectionObject['image']['frontRight']['img'].src = sectionObject['image']['frontRight']['src'];
                images.push(sectionObject['image']['frontRight']['img']);
            }
            else {
                console.log('%cИзображение не существует! Разворот: frontRight. Модуль: ' + sectionObject.name, 'background: #ffb9b9; color: #171414')
            }

            if(sectionObject['image']['front']['shadow'] !== '') {
                sectionObject['image']['front']['shadowImg'] = new Image();
                sectionObject['image']['front']['shadowImg'].src = sectionObject['image']['front']['shadow'];
                images.push(sectionObject['image']['front']['shadowImg']);
            }
            else {
                console.log('%cТень изображения не существует! Разворот: front. Модуль: ' + sectionObject.name, 'background: #ffb9b9; color: #171414')
            }

            if(sectionObject['image']['back']['shadow'] !== '') {
                sectionObject['image']['back']['shadowImg'] = new Image();
                sectionObject['image']['back']['shadowImg'].src = sectionObject['image']['back']['shadow'];
                images.push(sectionObject['image']['back']['shadowImg']);
            }
            else {
                console.log('%cТень изображения не существует! Разворот: back. Модуль: ' + sectionObject.name, 'background: #ffb9b9; color: #171414')
            }

            if(sectionObject['image']['frontLeft']['shadow'] !== '') {
                sectionObject['image']['frontLeft']['shadowImg'] = new Image();
                sectionObject['image']['frontLeft']['shadowImg'].src = sectionObject['image']['frontLeft']['shadow'];
                images.push(sectionObject['image']['frontLeft']['shadowImg']);
            }
            else {
                console.log('%cТень изображения не существует! Разворот: frontLeft. Модуль: ' + sectionObject.name, 'background: #ffb9b9; color: #171414')
            }

            if(sectionObject['image']['frontRight']['shadow'] !== '') {
                sectionObject['image']['frontRight']['shadowImg'] = new Image();
                sectionObject['image']['frontRight']['shadowImg'].src = sectionObject['image']['frontRight']['shadow'];
                images.push(sectionObject['image']['frontRight']['shadowImg']);
            }
            else {
                console.log('%cТень изображения не существует! Разворот: frontRight. Модуль: ' + sectionObject.name, 'background: #ffb9b9; color: #171414')
            }

            if(sectionObject['image']['front']['pillow'] !== '' && typeof sectionObject['image']['front']['pillow'] !== "undefined") {
                sectionObject['image']['front']['pillowImg'] = new Image();
                sectionObject['image']['front']['pillowImg'].src = sectionObject['image']['front']['pillow'];
                images.push(sectionObject['image']['front']['pillowImg']);
            }
            else if(sectionObject['image']['front']['shadow'] === '') {
                console.log('%cПодушка не существует! Разворот: front. Модуль: ' + sectionObject.name, 'background: #ffb9b9; color: #171414')
            }

            if(sectionObject['image']['back']['pillow'] !== '' && typeof sectionObject['image']['back']['pillow'] !== "undefined") {
                sectionObject['image']['back']['pillowImg'] = new Image();
                sectionObject['image']['back']['pillowImg'].src = sectionObject['image']['back']['pillow'];
                images.push(sectionObject['image']['back']['pillowImg']);
            }
            else if(sectionObject['image']['back']['shadow'] === '') {
                console.log('%cПодушка не существует! Разворот: back. Модуль: ' + sectionObject.name, 'background: #ffb9b9; color: #171414')
            }

            if(sectionObject['image']['frontLeft']['pillow'] !== '' && typeof sectionObject['image']['frontLeft']['pillow'] !== "undefined") {
                sectionObject['image']['frontLeft']['pillowImg'] = new Image();
                sectionObject['image']['frontLeft']['pillowImg'].src = sectionObject['image']['frontLeft']['pillow'];
                images.push(sectionObject['image']['frontLeft']['pillowImg']);
            }
            else if(sectionObject['image']['frontLeft']['shadow'] === '') {
                console.log('%cПодушка не существует! Разворот: frontLeft. Модуль: ' + sectionObject.name, 'background: #ffb9b9; color: #171414')
            }

            if(sectionObject['image']['frontRight']['pillow'] !== '' && typeof sectionObject['image']['frontRight']['pillow'] !== "undefined") {
                sectionObject['image']['frontRight']['pillowImg'] = new Image();
                sectionObject['image']['frontRight']['pillowImg'].src = sectionObject['image']['frontRight']['pillow'];
                images.push(sectionObject['image']['frontRight']['pillowImg']);
            }
            else if(sectionObject['image']['frontRight']['shadow'] === '') {
                console.log('%cПодушка не существует! Разворот: frontRight. Модуль: ' + sectionObject.name, 'background: #ffb9b9; color: #171414')
            }

        });

        let personObject = object.person.personImage;

        for (let key in personObject) {
            personObject[key].img = new Image();
            personObject[key].img.src = personObject[key].src;
            images.push(personObject[key].img);

            personObject[key].shadowImg = new Image();
            personObject[key].shadowImg.src = personObject[key].shadow;
            images.push(personObject[key].shadowImg);
        }

        object.configData.cross = new Image();
        object.configData.cross.src = '/wp-content/themes/classy/assets/img/configurator-canvas/popup/cross.png';
        images.push(object.configData.cross);

        object.configData.info = new Image();
        object.configData.info.src = '/wp-content/themes/classy/assets/img/configurator-canvas/popup/info.png';
        images.push(object.configData.info);

        object.configData.popupBg = new Image();
        object.configData.popupBg.src = '/wp-content/themes/classy/assets/img/configurator-canvas/popup/popup-bg.png';
        images.push(object.configData.popupBg);

        object.configData.materialAlertBg = new Image();
        object.configData.materialAlertBg.src = '/wp-content/themes/classy/assets/img/configurator-canvas/popup/no-color-alert-bg.png';
        images.push(object.configData.materialAlertBg);

        Object.keys(object.configData.interiors).forEach(function (interior) {
            let interiorObject = object.configData.interiors[interior];

            if(interiorObject['type'] === 'image') {
                interiorObject['img'] = new Image();
                interiorObject['img'].src = interiorObject['src'];
                images.push(interiorObject['img']);
            }
        });

        let loadedImages = 0;
        for(let i = 0; i < images.length; i++) {

            images[i].onload = function() {
                loadedImages++;
                if(loadedImages >= images.length) {
                    console.log('Loaded images');
                    callback(object);
                }
            };

            images[i].onerror = function () {
                console.log('%cНе могу загрузить картинку номер ' + i + '. URL картинки: ' + images[i].src, 'background: #ffb9b9; color: #171414')
                object.materialAvailable = false
                $('.no-image-alert--canvas').show()
                object.$loaderOptions.addClass('d-none')
            }
        }

    }

    /*Нарисовать комнату*/
    addRoom() {
        let object = this;

        if(object.roomInited) return;

        object.roomInited = true;

        let bg = new Konva.Line({
            points: [0, 0, object.containerWidth, 0, object.containerWidth, object.containerHeight, 0, object.containerHeight],
            fill: '#ffffff',
            closed: true
        });
        object.layer.add(bg);

        let roomImg = object.configData.interiors[1]['img'];

        let roomBg = new Konva.Image({
            x: 0,
            y: 0,
            width: 1262,
            height: 850,
            listening: false,
            image: roomImg,
            scaleX: 0.80,
            scaleY: 0.80,
            name: 'roomBg',
        });
        object.layer.add(roomBg);

        if(object.sofa.debug) {
            let start = new Konva.Circle({
                x: 0,
                y: 0,
                radius: 10,
                fill: 'red',
            });
            object.layer.add(start);
        }
    }

    /*Инициализируем драг-н-дроп*/
    initSections() {
        let object = this;
        let position = 0;
        let positionNew;
        let prepends = false;
        let pushToStart = 'none';

        $('.js-configurator-module').draggable({
            revert: "invalid",
            helper: "clone",
            appendTo: 'body',
            classes: {
                "ui-draggable": "module-drag-in-process"
            },
            drag: function(event, ui) {
                let id = $(this).data('id');
                let isAngle = Boolean($(this).data('angle'));/*угол*/
                let mirrorOf = $(this).data('mirror');/*зеркальный модуль*/
                let isChair = Boolean($(this).data('chair'));/*кресло*/
                let isPuff = Boolean($(this).data('puff'));/*пуф*/

                /*заносим особенности модуля в общий массив, для более легкой работы*/
                console.log(object.sofa);
                let specials = {
                    isAngle: isAngle,
                    isChair: isChair,
                    isPuff: isPuff,
                    mirrorOf: mirrorOf,
                    isArmrest: object.sofa.sections[id]['isArmrest'],
                    isMirror: typeof mirrorOf !== "undefined" && mirrorOf !== false,
                    isConnectedPuff: object.sofa.sections[id]['isConnectedPuff'],
                };

                /*получаем позицию модуля относительно канваса*/
                let uiPosition = {
                    left: (ui.offset.left - object.$container.offset().left) + $(this).width()/2,
                    top: (ui.offset.top - object.$container.offset().top) + $(this).height()/2
                };

                /*Если нет модулей-фантомов и не заблокировано их появление, то строим их, это наши подсказки*/
                if(!object.targetItems && !object.blockTargetItems) {

                    /*нужно получить модули, которые не являются серыми или фантомными*/
                    let drawnModules = object.sofa.state.filter((el) => {
                        return !el.targetItem && !el.highlight
                    })

                    object.sofa.removeHighlighted()
                    if(drawnModules.length > 0) {
                        object.createTargetItem(uiPosition, id, true, specials)
                        object.createTargetItem(uiPosition, id, false, specials)
                    }
                    else{
                        object.createTargetItem(uiPosition, id, true, specials)
                    }
                }
                else {
                    /*в зависимости от положения модуля получаем его параметры позиционирования*/
                    let positionObj = object.getPosition(uiPosition, object.sofa.state, isAngle, id, specials);
                    let pushToStartNew = typeof positionObj['pushToStart'] !== "undefined" ? positionObj['pushToStart'] : false;
                    let positionNew = positionObj['position'];

                    /*если у нас поменялась позиция, надо попробовать построить модуль*/
                    if (position !== positionNew || pushToStart !== pushToStartNew) {
                        position = positionNew;
                        pushToStart = pushToStartNew;
                        prepends = positionObj['prepend'];

                        /*может быть у нас есть отставные модули? Их положение надо поменять, если мы ставим угол*/
                        object.sofa.state.forEach(function (item, index) {
                            if(item.highlight && !item.targetItem) {
                                object.sofa.helpers.processChairPosition(item, object.sofa, true)
                            }
                        });

                        /*если позиция не нулевая (что значит не рисуем вообще) надо собрать данные и попробовать построить модуль*/
                        if(position && position !== 0) {

                            /*получаем серые модули которые у нас есть, вдруг они уже присутствуют*/
                            let highlightModules = object.sofa.state.filter((el) => {
                                return el.highlight
                            })

                            let data = {
                                id: id,
                                forwards: false,
                                prepends: prepends,
                                position: position,
                                highlight: 1,
                                connectedModule: object.sofa.sections[id]['connected_module'],
                                isAngle: object.sofa.sections[id]['isAngle'],
                                configurationWithAngle: object.sofa.sections[id]['configurationWithAngle'],
                                isChair: object.sofa.sections[id]['isChair'],
                                isPuff: object.sofa.sections[id]['isPuff'],
                                isArmrest: object.sofa.sections[id]['isArmrest'],
                                mirrorOf: mirrorOf,
                                isMirror: typeof mirrorOf !== "undefined" && mirrorOf !== false,
                                sizes: object.sofa.sections[id]['sizes'],
                                pushToStart: pushToStart,
                                from: 'from drag'
                            }

                            /*если это модуль с подлокотником - обрабатываем его позиционирование, проводим подмену на зеркальный если нужно*/
                            if(data.isArmrest) {
                                data = object.processMirrors(data)
                            }

                            /*проверка доступен ли модуль к построению*/
                            let allowModule = object.sofa.helpers.checkNonExistentConfigurations(object, Object.assign({}, data));

                            /**
                             * Проверяем, доступно ли построение данного модуля, а так же нет ли других "серых" модулей
                             * если да, то добавляем "серый" модуль
                             * */
                            if(allowModule && !highlightModules.length) {
                                object.blockTargetItems = true;
                                object.sofa.addSection(data);
                            }
                        }
                        else {
                            object.sofa.removeHighlighted()
                        }

                        object.sofa.rebuild();

                        object.layer.draw();
                    }
                }
            },
            stop: function( event, ui ) {
                object.sofa.removeHighlighted()
                object.sofa.removeTargetItems()

                object.sofa.rebuild();

                object.layer.draw();
            }
        });

        object.$container.droppable({
            drop: function( event, ui ) {
                let id = ui.draggable.data('id');

                object.sofa.removeTargetItems()
                object.sofa.removeHighlighted()

                if(position !== 0) {
                    let data = {
                        id: id,
                        prepends: prepends,
                        position: position,
                        highlight: 0,
                        connectedModule: object.sofa.sections[id]['connected_module'],
                        isAngle: object.sofa.sections[id]['isAngle'],
                        configurationWithAngle: object.sofa.sections[id]['configurationWithAngle'],
                        isChair: object.sofa.sections[id]['isChair'],
                        isPuff: object.sofa.sections[id]['isPuff'],
                        isArmrest: object.sofa.sections[id]['isArmrest'],
                        mirrorOf: object.sofa.sections[id]['mirrorOf'],
                        isMirror: typeof object.sofa.sections[id]['mirrorOf'] !== "undefined" && object.sofa.sections[id]['mirrorOf'] !== false,
                        sizes: object.sofa.sections[id]['sizes'],
                        pushToStart: pushToStart,
                        from: 'from drop'
                    }

                    if(data.isArmrest) {
                        data = object.processMirrors(data)
                    }

                    let allowModule = object.sofa.helpers.checkNonExistentConfigurations(object, Object.assign({}, data));

                    if(allowModule) {
                        object.sofa.addSection(data);
                    }
                    else {
                        object.sofa.helpers.processChairPosition(data, object.sofa, true);
                    }
                }

                object.sofa.rebuild();

                object.callSofaMethods(object.sofa.sections[id]['isChair']);

                object.layer.draw();
            }
        });
    }

    createTargetItem(uiPosition, id, prepends, specials) {
        let object = this
        let positionObj = object.getPosition(uiPosition, object.sofa.state, object.sofa.sections[id]['isAngle'], id, specials, prepends);

        if(positionObj['position'] !== 0) {
            object.targetItems = true

            let data = {
                id: id,
                prepends: prepends,
                position: positionObj['position'],
                highlight: 0,
                targetItem: true,
                connectedModule: object.sofa.sections[id]['connected_module'],
                isAngle: object.sofa.sections[id]['isAngle'],
                configurationWithAngle: object.sofa.sections[id]['configurationWithAngle'],
                isChair: object.sofa.sections[id]['isChair'],
                isPuff: object.sofa.sections[id]['isPuff'],
                isArmrest: object.sofa.sections[id]['isArmrest'],
                mirrorOf: null,
                isMirror: false,
                sizes: object.sofa.sections[id]['sizes'],
                from: 'from targetItem'
            }

            if(data.isArmrest) {
                data = object.processMirrors(data)
            }

            let allowModule = object.sofa.helpers.checkNonExistentConfigurations(object, Object.assign({}, data));

            if(allowModule) {

                object.sofa.addSection(data);

            }

            object.sofa.rebuild();

            object.sofa.setEdgeModules(data.isChair);

            object.layer.draw();
        }
    }

    /*Получить позицию модуля*/
    getPosition(position, state, isAngle, id, specials, prepends = null) {
        let object = this;
        let res;

        let anglesInfo = object.sofa.helpers.getAnglesInfo(state);

        if(specials.isChair) {
            res = object.positionChair(anglesInfo, position, isAngle, specials, prepends);
        }
        else {
            res = object.positionUsual(anglesInfo, position, isAngle, specials, prepends);
        }

        return res;
    }

    /*position of the usual module*/
    positionUsual(anglesInfo, position, isAngle, specials, prepends = null) {
        let res;
        let object = this

        let angleLeft = anglesInfo.angleLeft;
        let angleRight = anglesInfo.angleRight;
        let angleBackRight = anglesInfo.angleBackRight;
        let angleBackLeft = anglesInfo.angleBackLeft;
        let armrestAppend = anglesInfo.armrestAppend;
        let armrestPrepend = anglesInfo.armrestPrepend;
        let anyAnglesExist = angleLeft.exists || angleRight.exists || angleBackRight.exists || angleBackLeft.exists;


        if(prepends === null) {
            if(position.left < object.sofa.edgeModules['first'].centerX * object.fullScale + object.addModuleRadius * 0.75 &&
              position.left > object.sofa.edgeModules['first'].centerX * object.fullScale - object.addModuleRadius * 0.75 &&
              position.top < object.sofa.edgeModules['first'].centerY * object.fullScale + object.addModuleRadius * 0.75 &&
              position.top > object.sofa.edgeModules['first'].centerY * object.fullScale - object.addModuleRadius * 0.75) {
                prepends = true
                object.sofa.removeTargetItems()
            }
            else if (position.left < object.sofa.edgeModules['last'].centerX * object.fullScale + object.addModuleRadius &&
              position.left > object.sofa.edgeModules['last'].centerX * object.fullScale - object.addModuleRadius &&
              position.top < object.sofa.edgeModules['last'].centerY * object.fullScale + object.addModuleRadius &&
              position.top > object.sofa.edgeModules['last'].centerY * object.fullScale - object.addModuleRadius){
                prepends = false
                object.sofa.removeTargetItems()
            }
        }

        /*Если вне области перетаскивания*/
        if (((position.left < 0 || position.left > object.containerWidth) || (position.top < 0 || position.top > object.containerHeight))) {
            res =  {
                'position': 0,
                'prepend': false
            };
        }

        /*Если первый модуль*/
        // @todo HOT FIX Если только один элемент, угол, не получается что либо добавить справа
        // @todo Добавил коэффициент 0.75, что бы справа тоже могло добавляться (переписать)
        else if (prepends === true) {
            //console.log('true first');
            /*Если угол*/
            if (isAngle) {

                if(angleBackLeft.exists && !(angleBackRight.exists && angleBackRight.prepend)) {
                    res = {
                        'position': 'back',
                        'prepend': true
                    };
                }
                else if(angleBackRight.exists && angleBackRight.prepend && !(angleRight.exists && angleRight.prepend)) {
                    res = {
                        'position': 'frontRight',
                        'prepend': true
                    };
                }
                else if (angleRight.exists && angleRight.prepend) {

                    if(object.sofa.state.length < 2) {
                        res = {
                            'position': 'front',
                            'prepend': false
                        };
                    }
                    else {
                        res = {
                            'position': 'front',
                            'prepend': true
                        };
                    }
                }
                else {
                    res = {
                        'position': angleLeft.exists ? 'frontLeft' : 'front',
                        'prepend': angleLeft.exists || angleRight.exists
                    };
                }

                if(!anyAnglesExist || (angleRight.exists && !angleRight.prepend && !angleLeft.exists)) {

                    // console.log('!anyAnglesExist || (angleRight.exists && !angleRight.prepend && !angleLeft.exists)');

                    res = {
                        'position': 'front',
                        'prepend': false,
                        'pushToStart': true,
                    };
                }
            }
            /*Если обычный модуль*/
            else {

                if((angleBackLeft.exists && angleBackLeft.prepend) && !(angleBackRight.exists && angleBackRight.prepend)) {
                    res = {
                        'position': 'back',
                        'prepend': true
                    };
                }
                else if(angleBackRight.exists && angleBackRight.prepend) {
                    res = {
                        'position': angleRight.exists && angleRight.prepend ? 'front' : 'frontRight',
                        'prepend': true
                    };
                }
                else {
                    res = {
                        'position': angleLeft.exists ? 'frontLeft' : 'front',
                        'prepend': true
                    };
                }

                if(!anyAnglesExist || (angleRight.exists && !angleRight.prepend && !angleLeft.exists)) {
                    res = {
                        'position': 'front',
                        'prepend': false,
                        'pushToStart': true,
                    };
                }
            }

            if(armrestPrepend && !specials.isConnectedPuff && !specials.isPuff && !specials.isChair && object.sofa.state.length >= 1) {
                res =  {
                    'position': 0,
                    'prepend': false
                };
            }

        }

        /*Если последний модуль*/
        else if (prepends === false){
            //console.log('true last');
            if (isAngle) {
                if(angleBackRight.exists && !angleBackRight.prepend) {
                    res = {
                        'position': 'frontLeft',
                        'prepend': false
                    };
                }
                else if(angleBackLeft.exists && !angleLeft.exists) {
                    res = {
                        'position': 'front',
                        'prepend': false
                    };
                }
                else {
                    if(object.sofa.state.length < 2) {
                        res = {
                            'position': angleLeft.exists ? 'frontRight' : 'front',
                            'prepend': false
                        };
                    }
                    else {
                        res = {
                            'position': (angleRight.exists && !angleRight.prepend) ? 'back' : 'frontRight',
                            'prepend': false
                        };
                    }
                }
            }
            else {
                if(angleBackRight.exists && !angleBackRight.prepend && !(angleBackLeft.exists && !angleBackLeft.prepend)) {
                    res = {
                        'position': 'back',
                        'prepend': false
                    };
                }
                else if(angleBackLeft.exists && !angleBackLeft.prepend) {
                    res = {
                        'position': 'frontLeft',
                        'prepend': false
                    };
                }
                else {
                    res = {
                        'position': (angleRight.exists && !angleRight.prepend) ? 'frontRight' : 'front',
                        'prepend': false
                    };
                }
            }

            if(armrestAppend && !specials.isConnectedPuff && !specials.isPuff && !specials.isChair  && object.sofa.state.length >= 1) {

                // console.log('armrestAppend', armrestAppend);

                res =  {
                    'position': 0,
                    'prepend': false
                };
            }
        }

        else {
            res = {
                'position': 0,
                'prepend': false
            };
        }

        return res;
    }

    /*position of the usual module*/
    positionChair(anglesInfo, position, isAngle, specials, prepends = null) {
        let res;

        let angleLeft = anglesInfo.angleLeft;
        let angleRight = anglesInfo.angleRight;
        let angleBackRight = anglesInfo.angleBackRight;
        let angleBackLeft = anglesInfo.angleBackLeft;
        let armrestAppend = anglesInfo.armrestAppend;
        let armrestPrepend = anglesInfo.armrestPrepend;
        let anyAnglesExist = angleLeft.exists || angleRight.exists || angleBackRight.exists || angleBackLeft.exists;

        if(prepends === null) {
            if(position.left < object.sofa.edgeModules['first'].centerX * object.fullScale + object.addModuleRadius * 0.75 &&
              position.left > object.sofa.edgeModules['first'].centerX * object.fullScale - object.addModuleRadius * 0.75 &&
              position.top < object.sofa.edgeModules['first'].centerY * object.fullScale + object.addModuleRadius * 0.75 &&
              position.top > object.sofa.edgeModules['first'].centerY * object.fullScale - object.addModuleRadius * 0.75) {
                prepends = true
                object.sofa.removeTargetItems()
            }
            else if (position.left < object.sofa.edgeModules['last'].centerX * object.fullScale + object.addModuleRadius &&
              position.left > object.sofa.edgeModules['last'].centerX * object.fullScale - object.addModuleRadius &&
              position.top < object.sofa.edgeModules['last'].centerY * object.fullScale + object.addModuleRadius &&
              position.top > object.sofa.edgeModules['last'].centerY * object.fullScale - object.addModuleRadius){
                prepends = false
                object.sofa.removeTargetItems()
            }
        }

        /*Если вне области перетаскивания*/
        if ((position.left < 0 || position.left > object.containerWidth) || (position.top < 0 || position.top > object.containerHeight)) {
            res =  {
                'position': 0,
                'prepend': false
            };
        }

        /*Если первый модуль*/
        // @todo HOT FIX Если только один элемент, угол, не получается что либо добавить справа
        // @todo Добавил коэффициент 0.75, что бы справа тоже могло добавляться (переписать)
        else if (prepends === true) {

            if((angleBackLeft.exists && angleBackLeft.prepend) && !(angleBackRight.exists && angleBackRight.prepend)) {
                res = {
                    'position': 'back',
                    'prepend': true
                };
            }
            else if(angleBackRight.exists && angleBackRight.prepend) {
                res = {
                    'position': angleRight.exists && angleRight.prepend ? 'front' : 'frontRight',
                    'prepend': true
                };
            }
            else {
                res = {
                    'position': angleLeft.exists ? 'frontLeft' : 'front',
                    'prepend': true
                };
            }

            if(!anyAnglesExist || (angleRight.exists && !angleRight.prepend && !angleLeft.exists)) {
                res = {
                    'position': 'front',
                    'prepend': false,
                    'pushToStart': true,
                };
            }

            if(armrestPrepend && !specials.isConnectedPuff && !specials.isPuff && !specials.isChair && object.sofa.state.length >= 1) {

                res =  {
                    'position': 0,
                    'prepend': false
                };
            }

        }

        /*Если последний модуль*/
        else if (prepends === false){
            if(angleBackRight.exists && !angleBackRight.prepend && !(angleBackLeft.exists && !angleBackLeft.prepend)) {
                res = {
                    'position': 'back',
                    'prepend': false
                };
            }
            else if(angleBackLeft.exists && !angleBackLeft.prepend) {
                res = {
                    'position': 'frontLeft',
                    'prepend': false
                };
            }
            else {
                res = {
                    'position': (angleRight.exists && !angleRight.prepend) ? 'frontRight' : 'front',
                    'prepend': false
                };
            }

            if(armrestAppend && !specials.isConnectedPuff && !specials.isPuff && !specials.isChair  && object.sofa.state.length >= 1) {

                console.log('armrestAppend', armrestAppend);

                res =  {
                    'position': 0,
                    'prepend': false
                };
            }
        }
        else {
            res = {
                'position': 0,
                'prepend': false
            };
        }

        return res;
    }

    /*Вызвать методы для перерисовки и рассчета*/
    callSofaMethods(distancedModule = false) {
        let object = this;
        object.sofa.calculatePrice();
        object.sofa.checkAvailableItems(0);
        object.sofa.helpers.scaleFromState(object.sofa, object.person);
        if(object.person.isDrew) {
            object.redrawPerson();
        }
        object.sofa.calculateLinear();
        object.sofa.drawLinear();
        object.sofa.setEdgeModules(distancedModule);

    }

    /*Перерисовать человека*/
    redrawPerson() {
        object.person.group.remove();
        object.person.group.removeChildren();
        object.person.isDrew = false;
        let personItem = object.sofa.helpers.getPersonPositionBySofas(object.person, object.sofa);
        object.person.drawPerson(personItem);
        object.layer.add(object.person.group);
        object.layer.draw();
    }

    /*Сохранить состояние*/
    saveState(state) {
        sessionStorage.setItem('canvasState', JSON.stringify(state));
    }

    /**
     *
     * Process armrest position with mirrors
     * @param {object} data,
     * */
    processMirrors (data) {
        let object = this;

        if(data.isMirror) {

            switch (data.position) {
                case 'front' : {
                    object.sofa.sections.forEach((item, index) => {
                        if(index === Number(data.mirrorOf) - 1) {
                            data = object.getNewSectionData(index, data.prepends, data.position, item.mirrorOf, data.pushToStart, data);
                        }
                    })
                    break;
                }
                case 'frontLeft' : {
                    if(data.prepends) {
                        object.sofa.sections.forEach((item, index) => {
                            if(index === Number(data.mirrorOf) - 1) {
                                data = object.getNewSectionData(index, data.prepends, data.position, item.mirrorOf, data.pushToStart, data);
                            }
                        })
                    }
                    break;
                }
                case 'frontRight' : {
                    if(data.prepends) {
                        object.sofa.sections.forEach((item, index) => {
                            if(index === Number(data.mirrorOf) - 1) {
                                data = object.getNewSectionData(index, data.prepends, data.position, item.mirrorOf, data.pushToStart, data);
                            }
                        })
                    }
                    break;
                }
                case 'back' : {
                    break;
                }
                default : {
                    console.log('unexpected position');
                    break;
                }
            }
        }
        else {
            switch (data.position) {
                case 'front' : {
                    break;
                }
                case 'frontLeft' : {
                    if(!data.prepends) {
                        object.sofa.sections.forEach((item, index) => {
                            if(data.id === Number(item.mirrorOf) - 1) {
                                data = object.getNewSectionData(index, data.prepends, data.position, item.mirrorOf, data.pushToStart, data);
                            }
                        });

                    }
                    break;
                }
                case 'frontRight' : {
                    if(!data.prepends) {
                        object.sofa.sections.forEach((item, index) => {
                            if(data.id === Number(item.mirrorOf) - 1) {
                                data = object.getNewSectionData(index, data.prepends, data.position, item.mirrorOf, data.pushToStart, data);
                            }
                        });
                    }
                    break;
                }
                case 'back' : {
                    if(!data.prepends) {
                        object.sofa.sections.forEach((item, index) => {
                            if(data.id === Number(item.mirrorOf) - 1) {
                                data = object.getNewSectionData(index, data.prepends, data.position, item.mirrorOf, data.pushToStart, data);
                            }
                        });
                    }
                    break;
                }
                default : {
                    console.log('unexpected position');
                    break;
                }
            }
        }

        return data;
    }

    /*Получить данные нового модуля, который ставим в канвас*/
    getNewSectionData(id, prepends, position, mirrorOf, pushToStart, data) {
        return {
            id: id,
            forwards: false,
            prepends: prepends,
            position: position,
            highlight: data.highlight,
            targetItem: data.targetItem,
            connectedModule: object.sofa.sections[id]['connected_module'],
            isAngle: object.sofa.sections[id]['isAngle'],
            isChair: object.sofa.sections[id]['isChair'],
            isPuff: object.sofa.sections[id]['isPuff'],
            isArmrest: object.sofa.sections[id]['isArmrest'],
            mirrorOf: mirrorOf,
            isMirror: typeof mirrorOf !== "undefined" && mirrorOf !== false,
            sizes: object.sofa.sections[id]['sizes'],
            pushToStart: pushToStart,
            from: 'getNewSectionData'
        }
    }
}

export default ConfiguratorCanvas;
